<!--suppress CheckImageSize, JSUnresolvedVariable -->
<template>
  <div
    class="footer-bg"
    :style="{ backgroundImage: 'url(' + siteInfo.bottomBackground + ')' }"
  >
    <footer id="dyb_footer">
      <div class="container">
        <div class="row d-flex justify-content-around text-left">
          <div class="col-12 col-lg-4 my-3 d-flex justify-content-center">
            <div class="my-3 p-1">
              <!--<h3>联系 <span>信息</span></h3>-->
              <div class="info">
                <ul class="list-unstyled">
                  <li
                    v-if="
                      companyInfo.companyPhone !== '' ||
                        companyInfo.companyMarketPhone !== '' ||
                        companyInfo.companyHrPhone !== ''
                    "
                  >
                    <h4><i class="fa fa-phone"></i>电话</h4>
                    <p v-if="companyInfo.companyPhone !== ''">
                      商务：{{ companyInfo.companyPhone }}
                    </p>
                    <p v-if="companyInfo.companyMarketPhone !== ''">
                      发行：{{ companyInfo.companyMarketPhone }}
                    </p>
                    <p v-if="companyInfo.companyHrPhone !== ''">
                      万匠：{{ companyInfo.companyHrPhone }}
                    </p>
                  </li>
                  <li
                    v-if="
                      companyInfo.companyAddress !== '' ||
                        companyInfo.companyAddressEn !== ''
                    "
                  >
                    <!--<h4><i class="fa fa-map-marker"></i>Address</h4>-->
                    <p v-if="companyInfo.companyAddress !== ''">
                      地址：{{ companyInfo.companyAddress }}
                    </p>
                    <p v-if="companyInfo.companyAddressEn !== ''">
                      Address: {{ companyInfo.companyAddressEn }}
                    </p>
                  </li>
                  <li
                    v-if="
                      companyInfo.companyEmail !== '' ||
                        companyInfo.companyMarketEmail !== '' ||
                        companyInfo.companyHrEmail !== ''
                    "
                  >
                    <h4><i class="fa fa-envelope"></i> 联系邮箱</h4>
                    <p v-if="companyInfo.companyEmail !== ''">
                      商务：{{ companyInfo.companyEmail }}
                    </p>
                    <p v-if="companyInfo.companyMarketEmail !== ''">
                      发行：{{ companyInfo.companyMarketEmail }}
                    </p>
                    <p v-if="companyInfo.companyHrEmail !== ''">
                      招聘：{{ companyInfo.companyHrEmail }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-4 my-3"
            v-if="
              companyInfo.companyQq !== '' ||
                companyInfo.companyWx !== '' ||
                companyInfo.wxEwm !== ''
            "
          >
            <div class="my-3 p-1">
              <!--<h3>QQ <span>WEIXIN</span></h3>-->
              <div class="info">
                <ul class="list-unstyled">
                  <li>
                    <h4><i class="fa fa-qq"></i>QQ</h4>
                    <p v-if="companyInfo.companyQq !== ''">
                      QQ号：
                      {{ companyInfo.companyQq }}
                    </p>
                  </li>
                  <li>
                    <h4><i class="fa fa-weixin"></i>WeiXIN</h4>
                    <p v-if="companyInfo.companyWx !== ''">
                      微信号：{{ companyInfo.companyWx }}
                    </p>
                  </li>
                  <li v-if="companyInfo.wxEwm !== ''">
                    <img
                      alt="二维码"
                      :src="companyInfo.wxEwm"
                      class="img-thumbnail"
                      style="width: 110px;height: 110px;"
                    />
                    <p>扫一扫加入我们</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-4 my-3"
            v-if="friendLinks.length !== 0 || photoAlbums.length !== 0"
          >
            <div class="my-3 p-1">
              <div class="info mb-4" v-if="photoAlbums.length !== 0">
                <h3>团队 <span>相册</span></h3>
                <ul class="list-unstyled d-flex justify-content-around mt-4">
                  <li v-for="item in photoAlbums" :key="item.photoId">
                    <el-image
                      :src="item.photoUrl"
                      :preview-src-list="[item.photoUrl]"
                      style="width: 65px;height: 65px;"
                    >
                    </el-image>
                  </li>
                </ul>
              </div>
              <div class="follow-us" v-if="friendLinks.length !== 0">
                <h3>友情 <span>链接</span></h3>
                <ul class="list-unstyled d-flex justify-content-center mt-4">
                  <li v-for="item in friendLinks" :key="item.friendLinkId">
                    <a
                      :href="item.friendLinkUrl"
                      target="_blank"
                      :title="item.friendLinkName"
                    >
                      <img :src="item.friendLinkIcon" alt="logo" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container text-center">
          <div class="row">
            <div class="col-md-12 col-sm-12">
              <div class="block" style="font-size: 12px">
                <p class="p-0 m-0">{{ siteInfo.bottomInfo }}</p>
                <p style="color: #FF0017" class="p-0 m-0">
                  {{ siteInfo.bottomTips }}
                </p>
                <p class="p-0">
                  <a
                    target="_blank"
                    href="http://www.beian.miit.gov.cn"
                    style="color: #FF4F02;font-size: 15px"
                  >
                    {{ siteInfo.siteRecord }}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      companyInfo: {
        wxEwm: "",
        companyPhone: "",
        companyEmail: "",
        companyMarketPhone: "",
        companyMarketEmail: "",
        companyHrPhone: "",
        companyHrEmail: "",
        companyAddress: "",
        companyAddressEn: "",
        companyQq: "",
        companyWx: ""
      },
      siteInfo: {},
      photoAlbums: [],
      friendLinks: []
    };
  },
  mounted() {
    this.getCompanyInfo();
    this.getSiteInfo();
    this.getPhotoAlbumList();
    this.getLinksList();
  },
  methods: {
    getCompanyInfo() {
      this.axios
        .get("/companyInformation/getCompanyInfo")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.companyInfo = resp.data.data;
          }
        })
        .catch();
    },
    getSiteInfo() {
      this.axios
        .get("/siteInformation/getSiteInfo")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.siteInfo = resp.data.data;
          }
        })
        .catch();
    },
    getPhotoAlbumList() {
      this.axios
        .get("/photoAlbum/getPhotoAlbumList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.photoAlbums = resp.data.data;
          }
        })
        .catch();
    },
    getLinksList() {
      this.axios
        .get("/friendLink/getLinksList")
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.friendLinks = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.footer-bg {
  background-size: cover;
  background-repeat: no-repeat;
}

#dyb_footer {
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;

  .container {
    .row {
      div {
        h3 {
          font-size: 20px;

          span {
            color: #ff4f02;
          }
        }

        .info {
          ul {
            li {
              h4 {
                font-size: 18px;
                color: #ff4f02;

                i {
                  color: white;
                  margin-right: 20px;
                }
              }
            }
          }
        }

        .follow-us {
          ul {
            li {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
